import axios, { HeadersDefaults } from 'axios';

export default axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

export interface ApiDefaultHeaders extends HeadersDefaults {
  authorization: string;
}
